import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as externalInstitutions from '../../external-institutions'

export const RESOURCE = {
  payload: {
    description:
      'The overarching entity, such as a university or research center, that serves as the highest level in the organizational hierarchy.',
    dimension: externalInstitutions.RESOURCE.payload,
    level: 0,
    name: 'Institution',
    partialId: PartialId.Standard.create('institution'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
